import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./plugins/element.js";
import _ from "lodash";
import axios from "./axios";
import VueLocalStorage from "vue-localstorage";
import utils from "@/assets/js/utils";
import * as echarts from "echarts";
// let echarts = require('echarts');//亦可
import ResourceUpLoad from "@/components/common/ResourceUpLoad";
import ResourceListUpLoad from "@/components/common/ResourceListUpLoad";
import RejectDialog from "@/components/common/RejectDialog";
import AlertTip from "@/components/common/AlertTip";
import Tabs from "@/components/common/Tabs";
import { l, GetResourceUrl } from "@/assets/js/i18n.js";


//防止$alert重复弹窗 
//会导致$confirm弹窗关闭时有延迟，导致误判无法触发正常的$alert弹窗。nextTick也无法解决
// var elementAlert = Vue.prototype.$alert;
// Vue.prototype.$alert = (...params) => {
//     var targets = document.getElementsByClassName("el-message-box__wrapper")
//     console.log("targets", targets.length, targets[0], targets[0].style.display)
//     //不可仅用target.length判断,会导致全局出现一个弹窗后其他无法出现
//     if (!targets[0] || targets[0] && targets[0].style.display == "none") {
//       elementAlert(...params)
//     }
// };

//为Promise添加finally方法
Promise.prototype.finally = function (callback) {
  let P = this.constructor;
  return this.then(
    (value) => P.resolve(callback()).then(() => value),
    (reason) =>
      P.resolve(callback()).then(() => {
        throw reason;
      })
  );
};

//引入VueLocalStorage
Vue.use(VueLocalStorage);

//设置全局组件
Vue.component("ResourceUpLoad", ResourceUpLoad);
Vue.component("ResourceListUpLoad", ResourceListUpLoad);
Vue.component("RejectDialog", RejectDialog);
Vue.component("AlertTip", AlertTip);
Vue.component("Tabs", Tabs);



Vue.prototype.$EventBus = new Vue();

Vue.prototype._ = _;
Vue.prototype.axios = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$echarts = echarts;

Vue.prototype.VUE_APP_i18n = process.env.VUE_APP_i18n;
Vue.prototype.l = l;
Vue.prototype.GetResourceUrl = GetResourceUrl;


Vue.prototype.$openRouter = (data) => {
  var target = router.resolve(data);
  window.open(target.href, '_blank');
};

Vue.config.productionTip = false;
Vue.config.devtools = true; //允许生产模式下使用vue-devtools

// document.title = store.state.appConfig.title;

store.setSession("token", Vue.localStorage.get("token"));
store.setSession("host_token", Vue.localStorage.get("host_token"));
store.setSession("host_token_admin", Vue.localStorage.get("host_token_admin"));

router.beforeEach((to, from, next) => {
  console.log("router from", from, "to", to);

  if (store.state.axiosPromiseCancelArr.length) {
    store.state.axiosPromiseCancelArr.forEach((item) => {
      item && item(l("已取消"));
    });
    store.commit("clearAxiosPromiseCancel");
  }
  next();
});

router.afterEach(() => {
  //每次页面切换时回到顶部
  document.body.scrollTop = document.documentElement.scrollTop = 0;
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
